import Home from '@/viewsNew/Home'
import Case from '@/viewsNew/Case'
import Experts from '@/viewsNew/Experts'
import Schedule from '@/viewsNew/Schedule'
import Course from '@/viewsNew/Course'
import Review from '@/viewsNew/Review'
import Sponsor from '@/viewsNew/Sponsor'
import SubjectList from '@/viewsNew/SubjectList'
import SubjectDetail from '@/viewsNew/SubjectDetail'
import Teacher from '@/viewsNew/Teacher'
// import UserCenter from '@/viewsNew/UserCenter'
import UserCenter from '@/viewsNew/UserCenterNew'
import Order from '@/viewsNew/Order'
import Getexper from '@/viewsNew/Getexper'
import Login from '@/viewsNew/Login'

import Code from '@/viewsNew/Code'

// 提取可序列化的路由参数函数
// eslint-disable-next-line no-unused-vars
function extractSerializableParams (route) {
  const result = {}

  // 处理query参数
  if (route.query) {
    Object.keys(route.query).forEach(key => {
      const value = route.query[key]
      // 只保留基础类型（字符串、数字、布尔值、null）和可序列化的对象
      // if (value === null || typeof value !== 'object' || (typeof value === 'object' && value.constructor === Object)) {
      //   result[key] = value
      // }
      if (['number', 'string'].includes(typeof value)) {
        result[key] = value
      }
    })
  }

  // 处理params参数
  if (route.params) {
    Object.keys(route.params).forEach(key => {
      const value = route.params[key]
      // 只保留基础类型（字符串、数字、布尔值、null）
      // if (value === null || typeof value !== 'object') {
      //   result[key] = value
      // }
      if (['number', 'string'].includes(typeof value)) {
        result[key] = value
      }
    })
  }

  return result
}

export const baseRoutes = [
  // {}
]

export const viewRoutes = [
  { path: '/home', name: 'Home', component: Home, meta: {} },
  { path: '/schedule', name: 'Schedule', component: Schedule, meta: { title: '大会日程' } },
  { path: '/case', name: 'Case', component: Case, meta: { title: '精选案例' } },
  { path: '/experts', name: 'Experts', component: Experts, meta: { title: '演讲嘉宾' } },
  { path: '/review', name: 'Review', component: Review, meta: { title: '往期回顾' } },
  { path: '/sponsor', name: 'Sponsor', component: Sponsor, meta: { title: '赞助' } },
  { path: '/subject-list', name: 'SubjectList', component: SubjectList, meta: { title: '演讲主题' } },
  { path: '/user_center', name: 'UserCenter', component: UserCenter, meta: { title: '用户中心' } },
  { path: '/order', name: 'Order', component: Order, meta: { title: '线上购票' } },
  { path: '/Getexper', name: 'Getexper', component: Getexper, meta: { title: '体验票' } },
  { path: '/login', name: 'Login', component: Login, meta: { title: '登录' } },
  { path: '/code', name: 'Code', component: Code, meta: { base: true } },
  //
  { path: '/course/:cid?',
    name: 'Course',
    component: Course,
    props: (route) => {
      let cid = route.params.cid || route.query.cid || ''
      let param = extractSerializableParams(route)
      return {cid, param}
    },
    meta: { title: '课程详情' }
  },
  { path: '/teacher/:tid?',
    name: 'Teacher',
    component: Teacher,
    props: (route) => {
      let tid = route.params.tid || route.query.tid || ''
      let param = extractSerializableParams(route)
      return {tid, param}
    },
    meta: { title: '讲师介绍' }
  },
  { path: '/subject-detail/:id?',
    name: 'SubjectDetail',
    component: SubjectDetail,
    props: (route) => {
      let subjectid = route.params.id || route.query.id || ''
      let param = extractSerializableParams(route)
      return {subjectid, param}
    },
    meta: { title: '专题详情' }
  }
]



// WEBPACK FOOTER //
// ./src/router/routesNew.js